export default {"src":"/_next/static/media/BlueLOGO.f363d81d.svg","height":55,"width":221,"blurWidth":0,"blurHeight":0};